import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import arrayMove from "array-move";
import Pagination from "react-js-pagination";
import { fetchSurvey, updateSortedSurvey } from "SurveyAction";
import {
  dynamicFormModal,
  updateFomeName,
  updateFormList,
} from "FormBuilderAction";
import { screenHeightLeftFromTop } from "Constants";
import ContentIcon, { HEADING_SURVEY } from "ContentIcon";
import NoContent, { NO_SURVEY } from "NoContent";
import AddFormBuilder from "AddFormBuilder";
import EditFormBuilder from "EditFormBuilder";
import SurveyItem from "./survey-list-item";
import Loader from "Loader";
import LocaleStrings from "Languages";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
const itemCount = 50;
class Survey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      loading: true,
      desc: LocaleStrings.preparingSurvey,
      pageLoader: false,
    };
  }

  componentDidMount() {
    this.props.fetchSurvey(this.props.session, 0, (callback) => {
      this.setState({ loading: false });
    });
  }

  openModal = () => {
    var newObj = [];
    var formName = "Survey Form";
    var fixedObj = [];

    this.props.dynamicFormModal({
      key: "add",
      showModal: true,
      category: "survey",
      fixedFields: fixedObj,
    });
    this.props.updateFomeName(formName);
    this.props.updateFormList(newObj, [], "new");
  };

  callbackForm = () => {
    this.paginationCallback(1);
    this.callContentBoardStatus();
  };

  callContentBoardStatus = () => {
    if (this.props.surveyList && this.props.surveyList.count <= 1) {
      this.props.contentBoardStatus();
    }
  };

  paginationCallback = (pageNumber) => {
    let { session } = this.props;

    this.props.fetchSurvey(session, pageNumber, (callback) => {});

    this.setState({ ...this.state, pageNumber });
  };

  renderList() {
    let { surveyList } = this.props;
    let { pageNumber } = this.state;
    let pageDataLength =
      surveyList && surveyList.data ? surveyList.data.length : 0;

    return _.map(surveyList.data, (item, index) => {
      return (
        <SurveyItem
          key={`key_${index}`}
          listItem={item}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
          pagination={this.paginationCallback}
          contentBoardStatus={this.callContentBoardStatus}
        />
      );
    });
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    var arrAvailable = this.props.surveyList.data;

    arrAvailable = arrayMove(arrAvailable, oldIndex, newIndex);

    var newArrAvailable = [];

    this.setState({ activeCount: arrAvailable.length });

    arrAvailable.map((value, index) => {
      newArrAvailable.push({ ...value, displayorder: index + 1 });
    });
    this.setState({ pageLoader: true });
    this.props.updateSortedSurvey(
      this.props.session,
      newArrAvailable,
      (response) => {
        this.props.fetchSurvey(
          this.props.session,
          this.state.pageNumber,
          (callback) => {
            this.setState({ pageLoader: false });
          }
        );
      }
    );
  };

  /**
   * =============================================================================================
   */

  render() {
    let { deviceSize, surveyList, formBuilderModal } = this.props;
    let { pageNumber, pageLoader } = this.state;
    let pageDataLength = 0;
    let mapArr = [];

    if (surveyList && surveyList.data && surveyList.data.length > 0) {
      mapArr = surveyList.data;
      pageDataLength = surveyList.data.length;
    }

    var classCustom = "";
    if (pageLoader) {
      classCustom = "gamification-page-loading";
    }

    const SortableItem = SortableElement(
      ({ value, pageDataLength, currentPage }) => (
        <div>
          <SurveyItem
            key={value.eventid}
            listItem={value}
            pageDataLength={pageDataLength}
            currentPage={currentPage}
            style={{ zIndex: 10000 }}
            pagination={this.paginationCallback}
            contentBoardStatus={this.callContentBoardStatus}
          />
        </div>
      )
    );

    const SortableList = SortableContainer(
      ({ collection, pageDataLength, currentPage, disabled }) => {
        return (
          <div>
            {collection.map((value, index) => {
              return (
                <SortableItem
                  key={`section-${index}`}
                  index={index}
                  value={value}
                  pageDataLength={pageDataLength}
                  currentPage={currentPage}
                  disabled={disabled}
                />
              );
            })}
          </div>
        );
      }
    );

    return (
      <div>
        <div className="content-header-bar">
          <div className="pull-left h-100 vertical-align-center">
            <ContentIcon heading={HEADING_SURVEY} />
          </div>
          <div className="pull-right h-100 vertical-align-center content-end">
            <ul className="header-buttons">
              <li>
                <button
                  type="button"
                  className="btn btn-custom-blue"
                  onClick={this.openModal}
                >
                  {/* <i className="glyphicon glyphicon-plus i-custom-m"></i>{LocaleStrings.button_add_new} */}
                  <img
                    style={{ paddingRight: 8, paddingBottom: 3 }}
                    src="../../style/images/header-icons/plus.png"
                  ></img>
                  {LocaleStrings.button_add_new}
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : surveyList && surveyList.count > 0 ? (
            <div>
              <Row
                className="px-15"
                style={{ fontSize: 14, color: "#98a4af", fontWeight: 600 }}
              >
                <Col className="p-10" style={{ width: "35%" }}>
                  {LocaleStrings.polls_qa_survey_table_th_survey_name}
                </Col>
                <Col className="p-10">
                  {LocaleStrings.polls_qa_survey_table_th_survey_responses}
                </Col>
                <Col className="p-10 vertical-align-center gap-2">
                  <span>
                    {LocaleStrings.polls_qa_survey_table_th_survey_preview}
                  </span>
                  <i
                    className="fa fa-exclamation-circle tooltipss"
                    aria-hidden="true"
                    style={{ cursor: "pointer" }}
                  >
                    <span className="tooltiptext" style={{ marginTop: -24 }}>
                      {LocaleStrings.survey_tooltip_preview}
                    </span>
                  </i>
                </Col>
                <Col className="p-10 vertical-align-center gap-2">
                  <span>
                    {LocaleStrings.polls_qa_survey_table_th_survey_mandatory}
                  </span>
                  <i
                    className="fa fa-exclamation-circle tooltipss"
                    aria-hidden="true"
                    style={{ cursor: "pointer" }}
                  >
                    <span
                      className="tooltiptext"
                      style={{ marginTop: -40, marginRight: 10 }}
                    >
                      {LocaleStrings.survey_tooltip_mandatory}
                    </span>
                  </i>
                </Col>
                <Col className="p-10">
                  {LocaleStrings.polls_qa_survey_table_th_action}
                </Col>
              </Row>
              <div
                className={`px-15 col-md-12 ${classCustom}`}
                style={{
                  backgroundColor: "#ffffff",
                  backfaceVisibility: "hidden",
                  willChange: "transform",
                  userSelect: "none",
                  WebkitUserSelect: "none",
                  titleBarStyle: "hidden",
                }}
              >
                <SortableList
                  useDragHandle
                  collection={mapArr}
                  onSortEnd={this.onSortEnd}
                  pageDataLength={pageDataLength}
                  currentPage={pageNumber}
                />
              </div>

              {surveyList.count > itemCount ? (
                <Pagination
                  activePage={pageNumber}
                  itemsCountPerPage={itemCount}
                  totalItemsCount={surveyList.count}
                  pageRangeDisplayed={10}
                  onChange={this.paginationCallback}
                  style={{ float: "right" }}
                />
              ) : (
                ""
              )}
            </div>
          ) : (
            <NoContent contentType={NO_SURVEY} />
          )}
        </div>

        {formBuilderModal &&
        formBuilderModal.showModal &&
        formBuilderModal.key === "add" ? (
          <AddFormBuilder calledFrom={this.callbackForm} />
        ) : (
          ""
        )}

        {formBuilderModal &&
        formBuilderModal.showModal &&
        formBuilderModal.key === "edit" ? (
          <EditFormBuilder calledFrom={this.callbackForm} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
    surveyList: state.surveyList,
    formBuilderModal: state.formBuilderModal,
  };
}

export default connect(mapStateToProps, {
  fetchSurvey,
  dynamicFormModal,
  updateFomeName,
  updateFormList,
  updateSortedSurvey,
})(Survey);
